import AppConfig from "../../app.config";
export default class Role {
    static async get() {
        const res = await fetch(`${AppConfig.REST.URL}/role/`);
        const json = await res.json();
        return json;
    }
}
